"use client";

import React from "react";
import Image from "next/image";

import { ArrowUpRight } from "lucide-react";
const  chefImg = "https://cdn.msu.edu.in/YUV_6388_d7fb388a15.jpg";
const OurRoots = () => {
    return (
        <section className="w-full bg-[#081E2D] ">
            <div className="page-container py-10">
                <div className="w-full">
                    <div className="grid grid-cols-1  xl:grid-cols-[1fr_1fr]">
                        <div className="relative h-[300px]  md:mt-10 p-10 sm:h-[300px] md:h-[500px] bg-slate-200 order-1 md:order-2">
                            <Image
                                src={chefImg}
                                alt="Student during practical evaluation in a kitchen or lab setting"
                                fill
                                className="object-cover"
                            />
                        </div>

                        <div className=" text-white px-6 md:px-14 py-10 md:py-16 flex flex-col justify-between order-2">
                            <div className="max-w-xl space-y-4">
                                <h4
                                    style={{ fontFamily: "saans-bold" }}
                                    className="text-white text-xl md:text-[42px]">
                                    Our Roots
                                </h4>
                                <p
                                    className="text-[11px] md:text-[16px] leading-relaxed"
                                    style={{ fontFamily: "saans-regular" }}
                                >
                                    Our story began in 2012, with the establishment of Medhavi Foundation with a bold dream - to give every young Indian the power of skills and the dignity of employment. Registered as a not-for-profit, the Foundation joined hands with NSDC, industry leaders and State Skill Missions to turn this dream into a nationwide movement. Over the years, more than 45 Skill Academies and PMKK centres have been established, transforming the lives of over 5 lakh youth with training, technology and opportunity. This journey of impact became the very roots of Medhavi Skills University, founded in 2021, where skills, careers and aspirations come together to create a Viksit Bharat by 2047.
                                </p>
                            </div>

                            <button onClick={() => window.open("https://www.medhavifoundation.org/")}
                                className="group mt-6 inline-flex items-center cursor-pointer w-[280px] justify-center bg-[#FFA201] text-white text-[11px] md:text-sm font-medium px-4 py-2 md:px-6 md:py-3"
                                style={{ fontFamily: "saans-bold" }}
                            >
                                <span>Know more</span>
                                <ArrowUpRight
                                    className="ml-2 rotate-45 group-hover:-rotate-0 h-6 w-6  transition-transform duration-300 "
                                    strokeWidth={2.2}
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurRoots;